import { z } from "zod/v4";
import { requiredVizLabelEntriesSchema } from "@/lib/ai/visualization/views/shared/label-map";
import { timeSeriesLineComponentSchema } from "@/lib/ai/visualization/views/time-series-line/schema";

/**
 * `time-series-grouped-line` authoring contract。
 *
 * @remarks
 * grouped time-series は wide metrics と分け、`groupKey` と `metricKeys` を
 * 明示した strict shape だけを許可する。
 */
export const timeSeriesGroupedLineAuthoringSchema = z
  .object({
    xKey: z.string().min(1),
    xLabel: z.string().trim().min(1),
    groupKey: z.string().min(1),
    metricKeys: z.array(z.string().min(1)).min(1),
    metricLabelEntries: requiredVizLabelEntriesSchema,
  })
  .strict();

/**
 * `TimeSeriesGroupedLine` runtime component props schema。
 *
 * @remarks
 * runtime renderer surface は `TimeSeriesLine` と同じなので、contract も共有する。
 */
export const timeSeriesGroupedLineComponentSchema =
  timeSeriesLineComponentSchema;
